// Full-document render of the Oscar address-delete confirm view:
// PageSkeleton wrapping the legacy stearns breadcrumb shell ("Your Account /
// Your Addresses / Your Address Book") and the delete-confirmation form. The
// address-list crumb reuses cancel_url (both point at customer:address-list).
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressDeleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: "Your Account", href: props.profile_url },
                { label: "Your Addresses", href: props.cancel_url },
                { label: "Your Address Book" },
            ]}
            heading="Your Address Book"
        >
            <div className="account-form">
                <form method="post" action={props.action_url}>
                    <CSRFToken />
                    <p>{props.confirm_message}</p>
                    <p>
                        <strong>{props.address_summary}</strong>
                    </p>
                    <div className="form-group form-actions">
                        <button
                            type="submit"
                            aria-label="Submit"
                            className="button"
                            data-loading-text={props.deleting_label}
                        >
                            {props.delete_label}
                        </button>{" "}
                        {props.or_label}{" "}
                        <a
                            className="address-delete-link"
                            href={props.cancel_url}
                        >
                            {props.cancel_label}
                        </a>
                    </div>
                </form>
            </div>
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
